import * as searchActionTypes from "./searchActionTypes";
import { makeActionCreator } from "../../../../Application/actions/actionsBuilder";

export const setSearch = makeActionCreator(searchActionTypes.PEOPLE_USERS_OVERVIEW_SET_SEARCH, "search");
export const resetSearch = makeActionCreator(searchActionTypes.PEOPLE_USERS_OVERVIEW_RESET_SEARCH);
